<template>
	<div v-loading="loading" class="base_scroll_page">
		<div class="b_scroller">
			<!-- action -->
			<div style="font-size: 0;text-align: right;">
				<el-button type="primary" @click="handleAddClick">新增</el-button>
			</div>
			<!-- action end -->
			
			<!-- 表格 -->
			<div class="base_table" style="margin-top: 20px;">
				<el-table
					:data="tableData"
					style="width: 100%"
				>
					<el-table-column
						prop="name"
						label="名称"
					>
					</el-table-column>
					<el-table-column
						label="操作"
						width="400"
					>
						<template slot-scope="scope">
							<el-button
								@click="handleUpdateClick(scope.row)"
							>修改</el-button>
							<el-button
								style="color: #f00;"
								@click="handleDeleteClick(scope.row)"
							>删除</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!-- 表格 end -->
			
			<!-- 页码 -->
			<div class="clear_both" style="margin-top: 20px;">
				<div class="base_pager" style="float: right;">
					<el-pagination
						layout="total, prev, pager, next, jumper"
						next-text="下一页" 
						:total="total"
						:current-page="currentPage"
						@current-change="handlePageChange">
					</el-pagination>
				</div>
			</div>
			<!-- 页码 end -->
		</div>
		
		<!-- 新增弹框 -->
		<Popup 
			v-model="add_display"
			title="新增一级分类"
			confirmBtnText="添加"
			@confirmClick="handleAddPopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="add_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="addName_tip"><i class="b_icon"></i>请输入名称</template></div>
			</div>
		</Popup>
		<!-- 新增弹框 end -->
		
		<!-- 修改弹框 -->
		<Popup 
			v-model="update_display"
			title="修改一级分类"
			confirmBtnText="确定"
			@confirmClick="handleUpdatePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<div class="base_form_row">
					<span class="b_label"><span style="color: #f00;">*</span>名称</span>
					<el-input v-model="update_name" placeholder="名称"></el-input>
				</div>
				<div class="base_tip" style="padding: 0 0 0 120px;"><template v-if="updateName_tip"><i class="b_icon"></i>请输入名称</template></div>
			</div>
		</Popup>
		<!-- 修改弹框 end -->
		
		<!-- 删除弹出框 -->
		<Popup
			v-model="delete_display"
			title="提示"
			@confirmClick="handleDeletePopupConfirmClick"
		>
			<div style="padding: 15px;">
				<p style="color: #5f6468;line-height: 24px;">您确认要删除该条吗？</p>
			</div>
		</Popup>
		<!-- 删除弹出框 end -->
	</div>
</template>

<script>
	import Api from '../../../../../api/index.js'
	
	export default {
		mounted () {
			this.getList();
		},
		data () {
			return {
				loading: false,
				
				tableData: [],
				total: 0,
				currentPage: 1,
				
				add_display: false,
				add_name: '',
				addName_tip: false,
				
				update_display: false,
				update_id: '',
				update_name: '',
				updateName_tip: false,
				
				delete_display: false,
				delete_id: ''
			}
		},
		methods: {
			/*********************** @Events ***********************/
			// 点击新增
			handleAddClick () {
				this.add_name = '';
				this.addName_tip = false;
				this.add_display = true;
			},
			// 点击新增弹框确定按钮
			handleAddPopupConfirmClick () {
				if (!this.add_name.trim()) {
					this.addName_tip = true;
					return false;
				} else {
					this.addName_tip = false;
				}
				this.addPrimary();
			},
			
			// 点击修改
			handleUpdateClick (obj) {
				this.update_id = obj.id;
				this.update_name = obj.name;
				this.updateName_tip = false;
				this.update_display = true;
			},
			// 点击修改弹框确定按钮
			handleUpdatePopupConfirmClick () {
				const that = this;
				if (!this.update_name.trim()) {
					this.updateName_tip = true;
					return false;
				} else {
					this.updateName_tip = false;
				}
				that.$confirm(
					'此操作将修改该一级分类?', 
					'提示', 
					{
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.updatePrimary();
					}
				);
			},
			
			// 点击删除
			handleDeleteClick (obj) {
				this.delete_id = obj.id;
				this.delete_display = true;
			},
			// 点击删除弹框确定按钮
			handleDeletePopupConfirmClick () {
				const that = this;
				that.loading = true;
				var requestData = {
					id: that.delete_id
				};
				Api.deleteWebPrimary(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.delete_display = false;
						that.$message.success(res.data.message);
						that.currentPage = 1;
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			
			// 改变页码
			handlePageChange (page) {
				if (this.currentPage != page) {
					this.currentPage = page;
					this.getList();
				}
			},
			
			/*********************** @Function ***********************/
			// 获取数据
			getList () {
				const that = this;
				that.loading = true;
				var requestData = {
					limit: 10,
					pageNum: that.currentPage
				};
				Api.findWebPrimary(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.total = res.data.data.totalItems;
						that.tableData = [];
						for (var i = 0;i < res.data.data.data.length;i++) {
							var _o = res.data.data.data[i];
							that.tableData.push({
								id: _o.id,
								name: _o.typeName || ''
							});
						}
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 新增一级分类
			addPrimary () {
				const that = this;
				that.loading = true;
				var requestData = {
					fuSortName: that.add_name
				};
				Api.addWebPrimary(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.add_display = false;
						that.$message.success(res.data.message);
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			},
			// 修改一级分类
			updatePrimary () {
				const that = this;
				that.loading = true;
				var requestData = {
					fuSortName: that.update_name,
					id: that.update_id
				};
				Api.updateWebPrimary(requestData).then((res) => {
					that.loading = false;
					if (res.data.success) {
						that.update_display = false;
						that.$message.success(res.data.message);
						that.getList();
					} else {
						that.$message.error(res.data.message);
					}
				}, (e) => {
					that.loading = false;
					that.$message.error(e.message);
				});
			}
		}
	}
</script>

<style scoped>
	.back_tools_manage{ position: relative;width: 100%;height: 100%;padding: 15px; }
	.back_tools_manage .scroller{ width: 100%;height: 100%;padding: 15px;background: #fff;overflow-x: hidden;overflow-y: auto; }
</style>
